function ConditionEventListController(
  ConditionEventService, 
  CarService, 
  userViewService,
  eventsExportService,
  userService,
  CommonService,
  arraySortService,
  $interval,
  $timeout,
  $uibModal,
  $translate,
  __env,
  $scope
) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.events = [];
    ctrl.data = [];
    ctrl.currentView = userViewService.getView();
    ctrl.consist = CommonService.getConsist();
    ctrl.selectedCar = CommonService.getSelectedCar();
    ctrl.contentAreaId = 'div#conditionScrollContainer';
    ctrl.sortType = 'ACTIVATED';
    ctrl.sortReverse = true;
    ctrl.smallFont = false;
    ctrl.loadBusy = false;
    ctrl.showActive = true;
    ctrl.showDeactive = false;
    ctrl.showCategory = __env.profile !== 'VALE';
    ctrl.showBogie = __env.profile !== 'DEMO';
    ctrl.hasConditionEventRead = userService.hasConditionEventRead();
    $scope.$emit('gridlet-register-export', {
      excel: () => ctrl.exportTo('excel'),
      csv: () => ctrl.exportTo('csv'),
      isExporting: () => ctrl.fetching,
    });
    if (ctrl.hasConditionEventRead) {
      ctrl.loadEvents();
      startPoll();
    }
    ctrl.initialized = true;
  };

  ctrl.$onChanges = changes => {
    if (changes.settings && ctrl.initialized) {
      $timeout(() => {
        adjustContentSize(ctrl.contentAreaId);
        ctrl.loadEventsPage();
      }, 200);
    }
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.dataFetchPromise);
  };

  const adjustContentSize = (contentAreaSelectorId) => {
    $timeout(function () {
      ctrl.areaWidth = $(contentAreaSelectorId).width();
      // If adjust is fired when resize event is going on, size is incorrectly set to 100
      if (ctrl.areaWidth === 100) {
        ctrl.smallFont = false;
      } else {
        ctrl.smallFont = ctrl.areaWidth < 580;
      }
    }, 200);
  };

  const startPoll = () => {
    if (!ctrl.dataFetchPromise) {
      ctrl.lastLoad = DateTime.now();
      ctrl.dataFetchPromise = $interval(triggerFetchLoad, 10000);
    }
  };

  const triggerFetchLoad = () => {
    if (ctrl.lastLoad.diffNow('seconds').seconds < -9) {
      ctrl.loadEvents();
    }
  };

  ctrl.loadEvents = async () => {
    ctrl.data = [];
    const el = document.querySelector('#conditionEventsListGridletContainer');
    if (ctrl.loadBusy || el.scrollTop > 50) return;
    if (!ctrl.showActive && !ctrl.showDeactive) { 
      ctrl.events = [];
      return;
    }
    ctrl.loadBusy = true;
    let params = {
      count: ctrl.settings.fullscreen ? 100 : 25,
      skip: 0,
      eventSortType: ctrl.sortType,
      sortReverse: ctrl.sortReverse
    };

    fetchEvents(params).then(() => {
      ctrl.events = [...ctrl.data];
      adjustContentSize(ctrl.contentAreaId);
      ctrl.loadBusy = false;
      ctrl.oldScrollPos = angular.copy(ctrl.currentScrollPos);
    });
  };

  ctrl.loadEventsPage = async () => {
    ctrl.data = [];
    ctrl.currentScrollPos = document.querySelector('#conditionEventsListGridletContainer').scrollTop;
    if (ctrl.loadBusy || ctrl.oldScrollPos === ctrl.currentScrollPos) return;
    if (!ctrl.showActive && !ctrl.showDeactive) { 
      ctrl.events = [];
      return;
    }
    ctrl.loadBusy = true;
    let params = {
      count: ctrl.settings.fullscreen ? 100 : 25,
      skip: ctrl.events.length || 0,
      eventSortType: ctrl.sortType,
      sortReverse: ctrl.sortReverse
    };

    fetchEvents(params).then(() => {
      ctrl.filter();
      adjustContentSize(ctrl.contentAreaId);
      ctrl.loadBusy = false;
      ctrl.oldScrollPos = angular.copy(ctrl.currentScrollPos);
    });
  };

  const fetchEvents = async (params) => {
    if (ctrl.currentView === 'configuration') {
      const carArray = await CarService.carListForConsist({consist: ctrl.consist});
      params.cars = [...carArray];
    } else if (ctrl.currentView === 'carView') {
      params.cars = [CommonService.getSelectedCar()];
    }

    if (ctrl.showActive && !ctrl.showDeactive) {
      ctrl.data = await ConditionEventService.getActiveConditionEvents(params);
    } else if (!ctrl.showActive && ctrl.showDeactive) {
      ctrl.data = await ConditionEventService.getInactiveConditionEvents(params);
    } else if (ctrl.showActive && ctrl.showDeactive) {
      ctrl.data = await ConditionEventService.getConditionEvents(params);
    }
  };

  ctrl.changeActive = () => {
    if (ctrl.loadBusy) return;
    ctrl.showActive = !ctrl.showActive;
    ctrl.loadEvents();
  };

  ctrl.changeDeactive = () => {
    if (ctrl.loadBusy) return;
    ctrl.showDeactive = !ctrl.showDeactive;
    ctrl.loadEvents();
  };

  const isSameEvent = (event1, event2) => {
    return event1.id === event2.id &&
        event1.carId === event2.carId &&
        event1.activated === event2.activated &&
        event1.name === event2.name &&
        event1.asset.id === event2.asset.id;
  };

  ctrl.filter = () => {
    ctrl.data.forEach(item => {
      if (ctrl.events.find(event => isSameEvent(event, item))) return;

      const activeEvent = !item.deactivated;
      if (activeEvent && ctrl.showActive || !activeEvent && ctrl.showDeactive) {
        ctrl.events.push(item);
      }
    });
    sortEvents();
  };

  ctrl.setSortType = column => {
    if (ctrl.loadBusy) return;
    ctrl.sortReverse = (ctrl.sortType === column) ? !ctrl.sortReverse : false;
    ctrl.sortType = column;
    ctrl.events = [];
    ctrl.loadEvents();
  };

  const sortEvents = () => {
    switch(ctrl.sortType) { 
      case "CAR_ID": { 
        arraySortService.sortArrayWithKey(ctrl.events, 'carId',  ctrl.sortReverse);
        break;
      } 
      case "CATEGORY": {
        arraySortService.sortArrayWithKey(ctrl.events, 'category', ctrl.sortReverse);
        break;
      }
      case "ASSET_NAME": {
        arraySortService.sortArrayWithInnerValue(ctrl.events, 'asset', 'name', ctrl.sortReverse);
        break;
      } 
      case "EVENT_TYPE": { 
        arraySortService.sortArrayWithKey(ctrl.events, 'status', ctrl.sortReverse);
        break;
      }
      case "CI_NAME": {
        arraySortService.sortArrayWithInnerValue(ctrl.events, 'ciType', 'name', ctrl.sortReverse);
        break;
      }
      case "ACTIVATED": { 
        arraySortService.sortArrayWithKey(ctrl.events, 'activated', ctrl.sortReverse);
        break;
      }
      case "DEACTIVATED": { 
        arraySortService.sortArrayWithKey(ctrl.events, 'deactivated', ctrl.sortReverse);
        break;
      }       
      default: { 
        console.log("Invalid choice"); 
        break;           
      } 
    } 
  };

  ctrl.onEventClick = event => {
    ctrl.openConditionGraphModal(event);
  };

  ctrl.openConditionGraphModal = event => {
    const modalInstance = $uibModal.open({
      component: 'conditionGraphModal',
      windowClass: 'subSystemWindow',
      resolve: {
        alert: function () {
          return {
            asset: event.asset,
            ciType: event.ciType
          };
        },
      },
    });

    modalInstance.result.then(() => {}, () => {});
  };

  ctrl.exportTo = async (fileType) => {
    let criteria = angular.copy(ctrl.criteria);
    criteria.skip = 0;
    criteria.count = 50000;
    criteria.localTimezone = DateTime.local().zoneName;
    if (ctrl.currentView === 'configuration' || ctrl.currentView === 'carView') {
      let carArray;
      if (ctrl.currentView === 'configuration') {
        carArray = await CarService.carListForConsist({consist: ctrl.consist});
      } else if (ctrl.currentView === 'carView') {
        carArray = [];
        carArray.push(ctrl.selectedCar);
      }
      criteria.cars = '';
      carArray.forEach((el, index) => {
        if (index === carArray.length - 1) {
          criteria.cars += carArray[index];
        } else {
          criteria.cars += `${carArray[index]},`;
        }
      });
    }
    ctrl.fetching = true;
    if (fileType === 'excel') {
      await eventsExportService.exportToExcel(criteria, $translate.instant('export.latest-condition-events'), '');
    } else if (fileType === 'csv') {
      await eventsExportService.exportToCsv(criteria, $translate.instant('export.latest-condition-events'), '');
    }
    ctrl.fetching = false;
  };

}

angular
  .module('gridlets.module')
  .controller('ConditionEventListController', ConditionEventListController);